import styled from 'styled-components'
import { DEFAULT_CHART_HEIGHT } from '../GoogleChart'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: #303032;
  font-family: Barlow;
  max-width: 100%;
`

export const Content = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  overflow: auto;
`

export const VerticalLegend = styled.div`
  height: ${DEFAULT_CHART_HEIGHT}px;
  padding: 1rem 0;
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
`

const CHART_RANGE_LABEL_WIDTH = 190

export const HorizontalLegend = styled.div`
  display: grid;
  grid-column: 2;
  grid-template-columns: ${CHART_RANGE_LABEL_WIDTH}px 1fr ${CHART_RANGE_LABEL_WIDTH}px;
  margin: 0 ${CHART_RANGE_LABEL_WIDTH / 2}px;

  > :first-child {
    grid-column: 1;
    transform: translateX(-50%);
    text-align: center;
  }

  > :last-child {
    grid-column: 3;
    transform: translateX(50%);
    text-align: center;
  }
`

export const LineLegends = styled.div`
  grid-column: 2;
  display: flex;
  place-content: center;
  gap: 2rem;
`
